import { ActionCreator } from '@sendoutcards/core'
import { StripeOrderFragment } from 'src/graphql'
import { PurchaseTypes } from 'src/payments/containers/Payment'

export const clearStripeOrder = ActionCreator('STRIPE_ORDER_CLEAR')

export const createStripeOrder = ActionCreator(
  'STRIPE_ORDER_CREATE',
  (itemCode: string, coupon?: string) => ({ itemCode, coupon }),
)

export const createdStripeOrder = ActionCreator(
  'STRIPE_ORDER_CREATED',
  (stripeOrder: StripeOrderFragment) => ({ stripeOrder }),
)

export const purchaseError = ActionCreator('PURCHASE_ERROR')

export const closePayment = ActionCreator('CLOSE_PAYMENT')

export const initiatePurchase = ActionCreator('INITIATE_PURCHASE')

export const openPayment = ActionCreator(
  'OPEN_PAYMENT',
  (info: {
    data?: any
    items?: any[]
    purchaseType?: PurchaseTypes
    onSuccess?: () => void
    onError?: (error: any) => void
    currencyNeeded?: boolean
    coupon?: string | null
  }) => ({
    info,
  }),
)

export const purchaseSuccess = ActionCreator('PURCHASE_SUCCESS')
